const Config = {
  webServiceURL: "",
};
if (window.location.host.indexOf("localhost") >= 0) {
  Config.webServiceURL = "https://localhost:5001/api";
} else if (window.location.host.indexOf("pe2-react-test") >= 0) {
  Config.webServiceURL = "https://pe2-ws-test.dev.pruefexpress.app/api";
} else if (window.location.host.indexOf(".dev.") >= 0) {
  Config.webServiceURL = "https://pe2api.dev.pruefexpress.app/api";
} else if (window.location.host.indexOf(".beta.") >= 0) {
  Config.webServiceURL = "https://pe2api.beta.pruefexpress.app/api";
} else if (window.location.host.indexOf(".qa.") >= 0) {
  Config.webServiceURL = "https://pe2api.qa.pruefexpress.app/api";
} else if (window.location.host.indexOf(".stage.") >= 0) {
  Config.webServiceURL = "https://pe2api.stage.pruefexpress.app/api";
} else if (window.location.host.indexOf(".pruefexpress.") >= 0) {
  Config.webServiceURL = "https://wspe.pruefexpress.app/api";
} else if (window.location.host.indexOf("pe2-qa.dev") >= 0) {
  Config.webServiceURL = "https://pe2api-qa.dev.pruefexpress.app/api";
} else if (window.location.host.indexOf(".corpintra.net") >= 0) {
  Config.webServiceURL = "https://sgagawvets19.degag.corpintra.net:2401/api";
}
export default Config;
